export const editChannel = new BroadcastChannel("edit");
export const syncChannel = new BroadcastChannel("sync");
